import { useMutation, useQueryClient } from "@tanstack/react-query";
import { api } from "@utils/api";
import { useQueryErrorHandling } from "@hooks/useQueryErrorHandling";
import { onboardingQKeys } from "@hooks/queries/onboarding/queryKeys";

export const useApproveSession = () => {
  const handleErrors = useQueryErrorHandling();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (sessionId: string) => api.post(`onboarding/admin/queue/${sessionId}/approve`),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: onboardingQKeys.queue() });
    },
    onError: (res: any) => {
      console.error("[From Approve Session]", res);
      handleErrors(res, "mutation");
    },
  });
};
